import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries} from '../pages/layout/list-batteries/list-batteries.component';
import {Monthlyearnings} from '../pages/e-commerce/progress-section/progress-section.component';
import {Yearlyearnings} from '../pages/e-commerce/charts-panel/charts-panel.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TotalearningsService  {

  constructor(private afs: AngularFirestore) { }

  getMonthlyearnings() {
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.TotalEarningsDashboardCollection+'/Monthly').snapshotChanges().pipe(map(action => {
      const data = action.payload.data() as Monthlyearnings;
      const id = action.payload.id;
      return { id, ...data };
    }));
  }

  getPendingPayments() {
    return this.afs.doc('/UserWiseMonthlyData/UserData').snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      return data
    }));
  }

}
